import React, { useEffect, useState } from "react";
import './styles.css'
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { useNavigate, useLocation, replace } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { displayErrorToast, displaySuccessToast, isEmpty, isNull, isValidEmail, screenCaptureAnalytics } from "../../../utils/Utils";
import { registerRequest } from '../../../redux/user/user.action'
import { subscriptionListRequest, updateTransactionStatusRequest, updateTransactionStatusRequestStatus } from '../../../redux/subscription/subscription.action'
import { useDispatch, useSelector } from 'react-redux'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import NavBarComponent from "../../landing/nav-bar/navBar";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { config } from "../../../config";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";

const BusinessCreateAccount = props => {
    const [isLoading, setLoading] = useState(false)
    const { state } = useLocation()
    const [email, setEmail] = useState((!isEmpty(state) && !isEmpty(state.email)) ? state.email : '')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    let navigate = useNavigate();
    const { user, isLogin, loginErrorData } = useSelector(state => state.user)
    const { subscriptionListSuccess, subscriptionListError,
        updateTransactionStatusSuccess, updateTransactionStatusError, updateTransactionStatusReqStatus
    } = useSelector(state => state.subscription)
    const dispatch = useDispatch()
    const [mobile, setMobile] = useState()
    const [isReferred, setIsReferred] = useState(false)
    const [selectPlan, setSelectedPlan] = useState()
    const [showPaymentModal, setShowPaymentModal] = useState(false)
    const [showUpdateTransactionModal, setShowUpdateTransactionModal] = useState(false)
    const [isTncChecked, setIsTncChecked] = useState(false)

    useEffect(() => {
        if (config.environment === APP_CONSTANTS.ENVIRONMENT.PROD) {
            const data = {
                screen: 'BUSINESS_CREATE_ACCOUNT_PAGE',
                screenClass: 'BUSINESS_CREATE_ACCOUNT_PAGE'
            }
            screenCaptureAnalytics(data)
        }
        dispatch({ type: APP_CONSTANTS.LOGOUT })
        sessionStorage.clear()
        setLoading(true)
        const subscriptionPayload = {
            isActive: true,
            productCode: APP_CONSTANTS.PRODUCT_NAME
        }
        dispatch(subscriptionListRequest(subscriptionPayload))
        // if (!isEmpty(state) && !isEmpty(state.pricingPlan)) {
        //     let pricingPlan = PLAN_PRICING_LIST.find(e => e.type === state.pricingPlan.type)
        //     if (!isEmpty(pricingPlan)) {
        //         setSelectedPlan(pricingPlan)
        //     }
        // }
    }, [])

    useEffect(() => {
        if (!isNull(subscriptionListSuccess)) {
            setLoading(false)
            if (!isEmpty(state) && !isEmpty(state.pricingPlan)) {
                let pricingPlan = subscriptionListSuccess.data.find(e => parseFloat(e.subscriptionId) === parseFloat(state.pricingPlan))
                if (!isEmpty(pricingPlan)) {
                    setSelectedPlan(pricingPlan)
                }
            } else if (!isEmpty(state) && state.startFreeTrail === true) {
                let pricingPlan = subscriptionListSuccess.data.find(e => e.isTrailSubscription === true)
                if (!isEmpty(pricingPlan)) {
                    setSelectedPlan(pricingPlan)
                }
            }
        } else if (!isNull(subscriptionListError)) {
            setLoading(false)
        }
    }, [subscriptionListSuccess, subscriptionListError])

    useEffect(() => {
        if (updateTransactionStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            navigate(ROUTES.updateProfile, { replace: true })
        } else if (updateTransactionStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            setShowUpdateTransactionModal(true)
        }
        if (updateTransactionStatusReqStatus?.length) {
            dispatch(updateTransactionStatusRequestStatus(''))
        }
    }, [updateTransactionStatusSuccess, updateTransactionStatusError, updateTransactionStatusReqStatus])

    useEffect(() => {
        if (isLogin) {
            setLoading(false)
            displaySuccessToast('User registration successfull')
            sessionStorage.setItem(APP_CONSTANTS.USER, JSON.stringify(user.data))
            sessionStorage.setItem(APP_CONSTANTS.USER_TOKEN, user.data.authToken)
            // dispatch(displaySideBarAct(false))
            if (user.data.userDetails.isTrailSubscription) {
                navigate(ROUTES.updateProfile, { replace: true })
            } else {
                if (!isEmpty(user.data.userDetails.transaction)) {
                    setShowPaymentModal(true)
                } else {
                    sessionStorage.clear()
                    navigate(ROUTES.businessLogin, { replace: true })
                }
            }
        } else {
            if (loginErrorData) {
                setLoading(false)
                displayErrorToast(loginErrorData.message)
            }
        }
    }, [user, isLogin, loginErrorData])

    const handleRegisterClick = () => {
        if (isEmpty(firstName)) {
            displayErrorToast('First name cannot be blank')
        } else if (isEmpty(lastName)) {
            displayErrorToast('Last name cannot be blank')
        } else if (isEmpty(email)) {
            displayErrorToast('Email cannot be blank')
        } else if (!isValidEmail(email)) {
            displayErrorToast('Invalid email id')
        } else if (isEmpty(password)) {
            displayErrorToast('Password cannot be blank')
        } else if (isEmpty(confirmPassword)) {
            displayErrorToast('Confirm password cannot be blank')
        } else if (password !== confirmPassword) {
            displayErrorToast('Password does not match')
        } else if (isNull(mobile)) {
            displayErrorToast('Mobile number cannot be blank')
        } else if (isEmpty(selectPlan)) {
            displayErrorToast('Subscription plan not selected')
        } else if (isTncChecked === false) {
            displayErrorToast('Please agree to the Terms and Conditions to continue.')
        } else {
            setLoading(true)
            const mobileWithPlusSymbol = mobile.replace('+', "")
            const data = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                password: password,
                userType: APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS,
                productCode: APP_CONSTANTS.PRODUCT_NAME,
                mobile: parseInt(mobileWithPlusSymbol)
            }

            if (!isNull(selectPlan)) {
                data.subscriptionId = selectPlan.subscriptionId
            }

            dispatch(registerRequest(data))
        }
    }

    const handleUpdateTransactionStatus = () => {
        setLoading(true)
        const data = {
            transactionId: user.data.userDetails.transaction.transactionId,
            userId: user.data.userDetails.userId,
            transactionStatus: APP_CONSTANTS.TRANSACTION_STATUS.PAID
        }
        dispatch(updateTransactionStatusRequest(data))
        setShowUpdateTransactionModal(false)
    }

    const handlePaypalApprove = (data, actions) => {
        return actions.order.capture().then((details) => {
            console.log("Transaction completed:", details);
            console.log("Transaction completed:", details.status);
            if (details.status === 'COMPLETED') {
                setShowPaymentModal(false)
                handleUpdateTransactionStatus()
            }
        }).catch(err => {
            console.error("Transaction failed:", err);
            displayErrorToast('Transaction failed. Please try again.')
        });
    };

    const handlePaypalCancel = (data) => {
        displayErrorToast('You have cancelled the payment processing. Please process with payment to continue.')
    }

    const handlePaypalError = (error) => {
        console.log('paypal error', error)
        displayErrorToast('Error occured. Please try again.')
    }

    return (
        <>
            <NavBarComponent navigate={navigate}
                showHome={true}
                showBusinessLogin={true}
                isWhiteBackground={true} />
            <div className="sign-up-container">
                <div className="sign-up-img-layout-container">
                    <img src={require('../../../assets/sign-in-banner.jpg')} className='sign-up-img-container' />
                    <img src={require('../../../assets/sign-in-banner-tab.jpg')} className='sign-up-tab-img-container' />
                </div>
                <div className="sign-up-content-layout-container">
                    <div className="sign-up-logo-container">
                        <img src={require('../../../assets/logo_togethra_icon.png')} alt='logo' className="img" />
                    </div>
                    <div className='sign-in-heading'>Create Account <span className='sign-in-heading-label'>togethra</span></div>
                    <FormFieldLabel label='Enter details to register as business' className='sign-in-sub-text-label margin-bottom-10' />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            id='firstName'
                            onChange={e => setFirstName(e.target.value)}
                            placeholder='First Name'
                            type='text'
                            value={firstName} />
                        <CommonInputFloatHalf
                            id='lastName'
                            onChange={e => setLastName(e.target.value)}
                            placeholder='Last Name'
                            type='text'
                            value={lastName} />
                    </CommonInputRow>
                    <CommonInputFloatFull id='email'
                        onChange={e => setEmail(e.target.value)}
                        placeholder='Email'
                        type='text'
                        value={email} />
                    <div className="r-phone-input">
                        <PhoneInput
                            defaultCountry="US"
                            placeholder="Mobile Number"
                            value={mobile}
                            onChange={setMobile} />
                    </div>
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            id='password'
                            onChange={e => setPassword(e.target.value)}
                            placeholder='Password'
                            type='password'
                            value={password} />
                        <CommonInputFloatHalf
                            id='confirmPassword'
                            onChange={e => setConfirmPassword(e.target.value)}
                            placeholder='Confirm Password'
                            type='text'
                            value={confirmPassword} />
                    </CommonInputRow>
                    {!isEmpty(subscriptionListSuccess) && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={selectPlan}
                        getOptionLabel={e => e.longTitle}
                        getOptionValue={e => e}
                        options={subscriptionListSuccess.data}
                        placeholder='Select Pricing Plan'
                        onChange={e => {
                            setSelectedPlan(e)
                        }} />}
                    <div className="common-checkbox-container">
                        <input type="checkbox"
                            className="form-check-input common-checkbox"
                            checked={isTncChecked}
                            value={isTncChecked}
                            onChange={() => { setIsTncChecked(!isTncChecked) }} />
                        <label className="common-checkbox-label" for='tncCheckbox'> I agree to the <a href={config.tncUrl} target="_blank">Terms and Conditions</a></label>
                    </div>

                    {/* <div className="su-input-full">
                        <input
                            type="checkbox"
                            className="form-check-input su-input-text"
                            id="name"
                            checked={isReferred}
                            value={isReferred}
                            onChange={() => {
                                setIsReferred(!isReferred)
                            }}
                            required />
                        <label for="name" className="su-checkbox-label">Check if referred by someone</label>
                    </div> */}
                    {/* {isReferred && <div className="mt-2">
                        <PhoneInput
                            defaultCountry="US"
                            placeholder="Referrance Mobile Number"
                            value={agentPhoneNumber}
                            onChange={setAgentPhoneNumber} />
                    </div>} */}
                    <ButtonRow>
                        <CommonButton label='Submit'
                            isBig={true}
                            onClick={() => { handleRegisterClick() }} />
                    </ButtonRow>
                    {/* <div className="r-condition-label">By clicking submit you agree to our <a href={config.tncUrl} target='_blank' className="tc-a-link">Terms &amp; Conditions</a></div> */}
                    {/* <div className="r-condition-label">By clicking submit you agree to our <a href={`${config.webBaseUrl}${ROUTES.termsOfService}`} target='_blank' className="tc-a-link">Terms &amp; Conditions</a></div> */}
                </div>

            </div>
            <Modal
                onHide={() => { setShowPaymentModal(false) }}
                show={showPaymentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static" keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Congratulations! 🎉
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="bca-success-modal-container">
                        <p className="bca-smc-label-one">You have successfully registered on <strong>Togethra</strong>.</p>
                        <p className="bca-smc-label-two">We’re excited to have you onboard. Start exploring today!</p>
                        <p className="bca-smc-label-three">To proceed, please select the option below to complete your payment.</p>
                        <PayPalScriptProvider options={{
                            intent: "capture",
                            clientId: config.PP_ID
                        }}>
                            <PayPalButtons
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        intent: "CAPTURE",
                                        purchase_units: [{
                                            amount: {
                                                value: isEmpty(user) ? 0 : user.data.userDetails.transaction.amount,
                                                "currency_code": (!isEmpty(user) && !isEmpty(user.data.userDetails.transaction)) ? user.data.userDetails.transaction.currencyCode : 'USD'
                                            }
                                        }],
                                        application_context: {
                                            shipping_preference: "NO_SHIPPING",
                                            user_action: "PAY_NOW"
                                        },
                                        payer: {
                                            "name": {
                                                "given_name": !isEmpty(user) ? user.data.userDetails.firstName : "Firstname",
                                                "surname": !isEmpty(user) ? user.data.userDetails.lastName : "Lastname"
                                            },
                                            "email_address": !isEmpty(user) ? user.data.userDetails.email : "payer@example.com",
                                        }
                                    });
                                }}
                                onApprove={handlePaypalApprove}
                                onError={handlePaypalError}
                                onCancel={handlePaypalCancel}
                            />

                            {/* {success && <p style={{ color: "green" }}>Payment Successful!</p>}
                            {error && <p style={{ color: "red" }}>Error: {error}</p>} */}
                        </PayPalScriptProvider>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUpdateTransactionModal(false) }}
                show={showUpdateTransactionModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static" keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Error
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-text">Something went wrong while processing payment confirmation. Please click try again to continue</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-yes-btn" onClick={() => { handleUpdateTransactionStatus() }}>TRY AGAIN</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default BusinessCreateAccount